import { render, staticRenderFns } from "./ReceivablesCard.vue?vue&type=template&id=646e83e4"
import script from "./ReceivablesCard.vue?vue&type=script&lang=js"
export * from "./ReceivablesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports